// const api_admin = 'http://localhost:3030'
// const api_admin = 'http://epar.anvali.com.br:3000/imobon'
// const api_admin = 'http://epar.anvali.com.br:3000'
// const api_admin = 'https://api.e2par.com:3000'
const api_admin = 'https://apieparteste.anvali.com.br:3000'

export default api_admin